export const hideable = Symbol("hideable");
